import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import UpdateIcon from '@mui/icons-material/Update';
import React from 'react';

import { TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';
import { Box } from '_lib/components/Box/Box';
import { Button } from '_lib/components/Button/Button';
import { IconButton } from '_lib/components/IconButton/IconButton';
import { DatePicker } from '_lib/components/Pickers/DatePicker/DatePicker';
import { Tooltip } from '_lib/components/Tooltip/Tooltip';
import { DateUtils } from '_lib/utils/date.utils';

export interface AppointmentBookingControlsProps {
  selectedDate: Date | null;
  bookingControlsDisabled: boolean;
  clearButtonDisabled: () => boolean;
  nextAvailableDisabled: () => boolean;
  onDateSelectDecrement: () => void;
  onDateSelectChange: (value: Date) => void;
  onDateSelectIncrement: () => void;
  onNextAvailable: () => void;
  onRefreshAppointmentWindows: () => void;
  onClearFilters: () => void;
  timezone: TimezoneAbbreviationEnum;
}

export const AppointmentBookingControls = (props: AppointmentBookingControlsProps): React.ReactElement => {
  const {
    selectedDate,
    bookingControlsDisabled,
    clearButtonDisabled,
    nextAvailableDisabled,
    onDateSelectDecrement,
    onDateSelectChange,
    onDateSelectIncrement,
    onNextAvailable,
    onRefreshAppointmentWindows,
    onClearFilters,
    timezone
  } = props;

  const selectedDateIsToday = !!selectedDate && DateUtils.isSame(selectedDate, new Date(), 'day', { timezone });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 1 }}>
      <Box sx={{ display: 'flex' }}>
        <Tooltip title={selectedDateIsToday ? 'Cannot look for appointments before today' : ''} placement='bottom'>
          <span style={{ display: 'flex' }}>
            <IconButton
              disabled={bookingControlsDisabled || selectedDateIsToday}
              onClick={() => onDateSelectDecrement()}>
              <ChevronLeftIcon />
            </IconButton>
          </span>
        </Tooltip>
        <DatePicker
          sx={{ width: '190px' }}
          value={selectedDate}
          onChange={(newValue) => newValue && onDateSelectChange(newValue)}
          timezone={timezone}
          disabled={bookingControlsDisabled}
          disablePast
        />
        <IconButton disabled={bookingControlsDisabled} onClick={() => onDateSelectIncrement()}>
          <ChevronRightIcon />
        </IconButton>
        {!nextAvailableDisabled() && !bookingControlsDisabled && (
          <IconButton onClick={() => onNextAvailable()}>
            <SkipNextIcon />
          </IconButton>
        )}
      </Box>
      <Box sx={{ display: 'flex', padding: 1 }}>
        <IconButton onClick={() => onRefreshAppointmentWindows()}>
          <UpdateIcon />
        </IconButton>
        <Button
          text='CLEAR'
          variant='outlined'
          color='error'
          disabled={clearButtonDisabled()}
          onClick={() => onClearFilters()}
        />
      </Box>
    </Box>
  );
};
